export default "__VITE_ASSET__a263185d__"